import { InjectionToken } from '@angular/core';

export const GOOGLE_MAPS_KEY = new InjectionToken<string>('GOOGLE_MAPS_KEY');
